import type { FC } from 'react';

import type { UploaderState } from '@iconik-io/uploader/src/state';

import TooltipTrigger from '../../components/tooltip_trigger/tooltip_trigger';
import VARIANTS from '../../constants/variants';
import { openModal } from '../../ducks/modals_manager/slice';
import { useAppDispatch } from '../../store/react_redux_typed';
import Button from '../../ui/button/button';

import styles from './uploads_panel_widget.module.css';

type Props = {
  text: string;
  modal: string;
  item: UploaderState;
};

const ErrorButton: FC<Props> = ({ text, modal, item }) => {
  const dispatch = useAppDispatch();
  return (
    <TooltipTrigger tooltipText={text} tooltipClass={styles.error}>
      <Button
        onClick={() => {
          dispatch(
            openModal({
              id: modal,
              contextItems: [item],
            }),
          );
        }}
        variant={VARIANTS.DANGER}
        iconName="message_warning"
        wideBasis={false}
        aria={{
          label: `Error: ${text}`,
        }}
      />
    </TooltipTrigger>
  );
};

export default ErrorButton;
